/**
 *
 * AnnouncementDialogContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import * as actionCreators from './actions';
import AnnouncementDialog from "./AnnouncementDialog";
import makeSelectAnnouncement, {makeSelectAnnouncementDialogOpen} from "./selectors";
import {removeAnnouncement} from "domain/Announcements/actions";

class AnnouncementDialogContainer extends React.PureComponent {

    // componentDidMount() {
    //     const {data, load} = this.props
    //     load(data.id)
    // }


    render() {
        const {
            announcement,
            closeDialog,
            open,
            removeAnnouncement,
            ...restProps
        } = this.props;

        return (
            <AnnouncementDialog
                announcement={announcement}
                closeDialog={closeDialog}
                open={open}
                removeAnnouncement={removeAnnouncement}
                {...restProps}
            />
        );
    }
}

AnnouncementDialogContainer.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    id: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
    open: makeSelectAnnouncementDialogOpen(),
    announcement: makeSelectAnnouncement()
});

function mapDispatchToProps(dispatch) {
    return {
        openDialog: (id) => dispatch(actionCreators.openDialog()),
        closeDialog: () => dispatch(actionCreators.closeDialog()),
        removeAnnouncement: (id) => dispatch(removeAnnouncement(id)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementDialogContainer);